export class InfectiousPatientContactType {
    code: string;
    name: string;
    nameUz: string;
    nameEn: string;
    nameUzLatn: string;
    nameKa: string;
    nameKaLatn: string;
    id: string;
}